var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Imóvel" } }),
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _vm.imovel.possuiCar || _vm.imovel.numeroReciboCar
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Número do recibo:")
                  ]),
                  _c("span", { staticClass: "labelNumeroRecibo" }, [
                    _vm._v(
                      "   " + _vm._s(_vm.filterNull(_vm.imovel.numeroReciboCar))
                    )
                  ])
                ])
              ])
            : _vm._e(),
          !_vm.imovel.possuiCar && !_vm.imovel.numeroReciboCar
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Número do imóvel:")
                  ]),
                  _c("span", { staticClass: "labelNumeroRecibo" }, [
                    _vm._v("   " + _vm._s(_vm.filterNull(_vm.imovel.nome)))
                  ])
                ])
              ])
            : _vm._e(),
          !_vm.imovel.possuiCar && !_vm.imovel.numeroReciboCar
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Município do imóvel:")
                  ]),
                  _c("span", { staticClass: "labelNumeroRecibo" }, [
                    _vm._v(
                      "   " + _vm._s(_vm.filterNull(_vm.imovel.municipio.nome))
                    )
                  ])
                ])
              ])
            : _vm._e(),
          !_vm.imovel.possuiCar && !_vm.imovel.numeroReciboCar
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Área do imóvel:")
                  ]),
                  _c("span", { staticClass: "labelNumeroRecibo" }, [
                    _vm._v("   " + _vm._s(_vm.filterNull(_vm.imovel.area)))
                  ])
                ])
              ])
            : _vm._e(),
          !_vm.imovel.possuiCar && !_vm.imovel.numeroReciboCar
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Vias de acesso/localização:")
                  ]),
                  _c("span", { staticClass: "labelNumeroRecibo" }, [
                    _vm._v(
                      "   " + _vm._s(_vm.filterNull(_vm.imovel.descricaoAcesso))
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.inputsExtraCadastro.imovel.nomeImovelPropriedade
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Nome do imóvel/Propriedade:")
                  ]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.imovel.nomeImovelPropriedade))
                  ])
                ])
              ])
            : _vm._e(),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Tempo de ocupação:")
              ]),
              _c("span", [
                _vm._v(
                  "  " +
                    _vm._s(_vm.filterNull(_vm.imovel.tempoOcupacao)) +
                    " ano(s)"
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Há ocupantes anteriores:")
              ]),
              _c("span", [_vm._v("  " + _vm._s(_vm.hasOcupantesAnteriores))])
            ])
          ]),
          _vm.tipo === "ONEROSO"
            ? _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s("Possui outros imóveis no " + _vm.ESTADO + ":")
                    )
                  ]),
                  _c("span", [_vm._v("  " + _vm._s(_vm.hasOutrosImoveis))])
                ])
              ])
            : _vm._e(),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Há conflitos no imóvel:")
              ]),
              _c("span", [_vm._v("  " + _vm._s(_vm.hasConflitos))])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _vm.imovel.conflitos
              ? _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Nº do processo judicial:")
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.filterNull(_vm.imovel.numeroProcessoJudicial)
                        )
                    )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm.imovel.documentos
        ? _c(
            "el-row",
            { staticClass: "pad5" },
            [
              _c("app-resumo-documentos", {
                staticClass: "margin-top",
                attrs: {
                  documentos: _vm.imovel.documentos,
                  codigoCadastro: "imovel"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.imovel.termo
        ? _c(
            "el-row",
            { staticClass: "pad5" },
            [
              _c("el-checkbox", {
                attrs: { required: true, disabled: true },
                model: {
                  value: _vm.imovel.termo,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "termo", $$v)
                  },
                  expression: "imovel.termo"
                }
              }),
              _c("span", [_vm._v("  " + _vm._s(_vm.formatarMensagem()))])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86dc9788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86dc9788","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/ResumoImovel.vue
// module id = null
// module chunks = 